import api from '../lib/axios';
export async function getDiscoveryStats(limit = 50) {
    const { data } = await api.get('/api/superadmin/discovery/stats', { params: { limit } });
    return data.data;
}
export async function getDiscoveryInterests(params = {}) {
    const { data } = await api.get('/api/superadmin/discovery/interests', { params });
    return data.data;
}
export async function updateDiscoveryInterest(id, payload) {
    const { data } = await api.patch(`/api/superadmin/discovery/interests/${id}`, payload);
    return data.data;
}
